
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import util from '@/javascript/util'
import EsQuery from '@/javascript/esQuery'
import Swiper from 'swiper'
import goSearch from '@/components/jts-components/search-box/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
components: {
Toast,
Tab,
TabItem,
goSearch,
goBack,
Footer
},
data () {
return {
minHeight: 0,
pageNo: 0,
pageSize: 10,
currentId: 0,
newsAllList: [],
topNewsList: [],
infiniteStatus: false, //控制加载，true的话停止加载，false的话根据infiniteAll判断
infiniteAll: false, //在infiniteStatus为false的情况下，infiniteAll为false停止加载，为true继续加载
}
},
filters: {

formatDate (datestamp) {
if (datestamp != null) {
let result = new Date(Number(datestamp))
const y = result.getFullYear()
let m = result.getMonth() + 1
m = m < 10 ? ('0' + m) : m
let d = result.getDate()
d = d < 10 ? ('0' + d) : d
let h = result.getHours()
h = h < 10 ? ('0' + h) : h
let n = result.getMinutes()
n = n < 10 ? ('0' + n) : n
let s = result.getSeconds()
s = s < 10 ? ('0' + s) : s
return `${y}-${m}-${d} ${h}:${n}`
}
}
},

methods: {

windowScroll: function () {

if (util.pullUpLoad()) {
this.infinite()
}
},
getTopNewList () {
const newsEsQuery = new EsQuery()
const querystring = require('querystring')
const catalogCode = this.$route.query.code
newsEsQuery
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
.addStartWith("catalogCode", catalogCode, newsEsQuery.and, false)

.addSort("createdDate", newsEsQuery.desc, false)

.addPage(0, 100)

if (catalogCode == '00000000,1720488224033') {
newsEsQuery.addString('tags', '推荐', newsEsQuery.and, false)

}
const newsJsList = JSON.stringify(newsEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.newsList,
'esJsonQuery': newsJsList
})).then(res => {
if (res.data.data.length > 0) {
this.$set(this, 'topNewsList', res.data.data.map(item => {
item._source.titleImage = item._source.images && item._source.images[0].filter(img => img.fileIdentify ? img.fileIdentify == 'titleImage' : img.fileIdentify == '')[0].fileUrl
return item
}))
}
}).then(() => {
this.$nextTick(function () {
new Swiper('.wen-swiper', {
loop: false,
autoplay: 5000,
slidesPerView: 'auto',
spaceBetween: 20,
observer: true,
observeParents: true,
})
})
})
},
getAllList () {
const newsEsQuery = new EsQuery()
const querystring = require('querystring')
const catalogCode = this.$route.query.code

newsEsQuery
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
.addStartWith("catalogCode", catalogCode, newsEsQuery.and, false)
.addString("top", 0, newsEsQuery.and, false)
.addSort("createdDate", newsEsQuery.desc, false)


.addPage(this.pageNo * this.pageSize, this.pageSize)
const newsJsList = JSON.stringify(newsEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.newsList,
'esJsonQuery': newsJsList
})).then(res => {
this.newsAllList = [...this.newsAllList, ...res.data.data]

if (res.data.data.length < this.pageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
})
},


infinite () {
/*if (this.newsList.length == 0) {
return;
}*/
if (this.newsAllList.length == 0) {
return
}
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}
this.infiniteStatus = true;
this.pageNo += 1
this.getAllList()
},
handleTab (label, index) {
this.currentId = index
this.infiniteAll = true
this.infiniteStatus = true
window.scrollTo(0, 0)
this.newsList = []
this.newsAllList = []
this.pageNo = 0
this.pageSize = 10
},
goDetails (item) {
if (item._source.link) {
window.location.href = item._source.link
} else {
this.$router.push({ path: `/news-details?id=${item._source.id}` })
}
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight
document.title = '资讯'

window.addEventListener("scroll", this.windowScroll)


this.getTopNewList()
this.getAllList()
},
beforeDestroy () {
window.removeEventListener('scroll', this.windowScroll)
}
}
